<p-confirmDialog key="export" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="OptionSize">
	<div class="SubMenu">
		<h4>Students:</h4>

		<div class="GridMenu">
			<label>School:</label>
			<caass-schoolselector [Disabled]="IsLoading() == true" [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
			</caass-schoolselector>

			<label>Grade Level:</label>
			<p-dropdown
				[disabled]="IsLoading() == true"
				[options]="lstGradeLevel"
				[(ngModel)]="SelectedGradeLevel"
				optionLabel="GradeLevelDesc"
				[filter]="true"
				filterBy="GradeLevelDesc"
				[showClear]="false"
				placeholder="Select a Grade Level"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="SelectedGradeLevel">
						<div class="form-control NoBorder" style="text-align: left">
							{{ SelectedGradeLevel.GradeLevelDesc }}
						</div>
					</div>
				</ng-template>
				<ng-template let-GradeLevelItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left">
							{{ GradeLevelItem.GradeLevelDesc }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>

			<label>Academy:</label>
			<p-dropdown
				[disabled]="IsLoading() == true"
				[options]="lstAcademy"
				[(ngModel)]="SelectedAcademy"
				optionLabel="AcademyDesc"
				[filter]="true"
				filterBy="AcademyDesc"
				[showClear]="false"
				placeholder="Select an Academy"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="SelectedAcademy">
						<div class="form-control NoBorder" style="text-align: left">
							{{ SelectedAcademy.AcademyDesc }}
						</div>
					</div>
				</ng-template>
				<ng-template let-AcademyItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left">
							{{ AcademyItem.AcademyDesc }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>

			<label>Homeroom:</label>
			<p-dropdown
				[disabled]="IsLoading() == true"
				[options]="lstHomeroom"
				[(ngModel)]="SelectedHomeroom"
				optionLabel="HomeRoom"
				[filter]="true"
				filterBy="HomeRoom"
				[showClear]="false"
				placeholder="Select a Homeroom"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="SelectedHomeroom">
						<div class="form-control NoBorder" style="text-align: left">
							{{ SelectedHomeroom.HomeRoom }}
						</div>
					</div>
				</ng-template>
				<ng-template let-HomeroomItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left">
							{{ HomeroomItem.HomeRoom }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>

			<label>Group:</label>
			<p-dropdown
				[disabled]="IsLoading() == true"
				[options]="lstGroup"
				[(ngModel)]="SelectedGroup"
				optionLabel="GroupName"
				[filter]="true"
				filterBy="GroupName"
				[showClear]="false"
				placeholder="Select a Group"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="SelectedGroup">
						<div class="form-control NoBorder" style="text-align: left">
							{{ SelectedGroup.GroupName }}
						</div>
					</div>
				</ng-template>
				<ng-template let-GroupItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left">
							{{ GroupItem.GroupName }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>

			<label>Active:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="ActiveOptionID" [(ngModel)]="ActiveOptionID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>

			<label>Already Printed:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="AlreadyPrintedID" [(ngModel)]="AlreadyPrintedID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstAlreadyPrinted" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>

	<div class="SubMenu TopMargin">
		<h4>Format:</h4>

		<div class="GridMenu">
			<label>Format:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="SelectedFormatOption" [(ngModel)]="SelectedFormatOption">
				<option *ngFor="let o of lstFormatOptions" [ngValue]="o">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onExport()">Export</button>
	<button [disabled]="IsProcessing == true" class="btn btn-warning" (click)="onClose()">Close</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
